// extracted by mini-css-extract-plugin
export default {"container":"Checkout_container__ZGtTU"};